<template>
<div :class="{heightPc:$mq==='pc',heightSp:$mq==='sp'}">
  <v-card>
    <v-card-actions class="ma-0">
      <v-card-text class="text-left px-0" style="color:#707070; font-size:14px">
        <span v-if="vote[0]&&vote[0].isAdmitOpen=='open'">公開投票</span>
        <span v-if="vote[0]&&vote[0].isAdmitOpen=='private'">匿名投票</span>
        <span style="font-size:8px;">（有効投票数：<span v-if="sumnum" v-text="sumnum"></span>）</span>
      </v-card-text>
      <v-spacer></v-spacer>
      <v-btn v-if="false" class="rounded-pill white--text" color="#707070" @click="result_print=true">結果を出力する</v-btn>
    </v-card-actions>
    <!--自由選択肢 ４つまでと５つ以上で分割-->
    <div v-if="vote[0]&&vote[0].voteType==='自由選択肢'&&vote[0].voteOptions.length<=4">
      <v-row>
        <v-col cols="6" v-if="this.vote[0].voteOptions[3]">
          <v-card-text class="text-h4 py-0"><font color="#E05922">{{this.vote[0].voteOptions[3]}}</font></v-card-text>
          <v-card-text class="text-h6 py-0"><font color="#E05922"><span v-text="sum4num"></span>票</font></v-card-text>
          <v-card-text class="py-0" style="color:#707070" v-if="vote[0]&&vote[0].isAdmitDele===true">委任得票数:<span v-text="vote[0].optionsDele.n4.length" v-if="vote[0]"></span>票</v-card-text>
          <v-card-text class="py-0" style="color:#707070">得票数：<span v-text="vote[0].options.n4.length" v-if="vote[0]"></span>票</v-card-text>
        </v-col>
        <v-col cols="6">
          <v-card-text class="text-h4 py-0"><font color="#008CFF">{{this.vote[0].voteOptions[0]}}</font></v-card-text>
          <v-card-text class="text-h6 py-0"><font color="#008CFF"><span v-text="sum1num"></span>票</font></v-card-text>
          <v-card-text class="py-0" style="color:#707070" v-if="vote[0]&&vote[0].isAdmitDele===true">委任得票数：<span v-text="vote[0].optionsDele.n1.length" v-if="vote[0]"></span>票</v-card-text>
          <v-card-text class="py-0" style="color:#707070">得票数：<span v-text="vote[0].options.n1.length" v-if="vote[0]"></span>票</v-card-text>
        </v-col>
      </v-row>
      <chart :chartData="chartData" v-if="vote[0]" :options="options" :height="height" :width="width"></chart>
      <v-row>
        <v-col cols="6"  v-if="this.vote[0].voteOptions[2]">
          <v-card-text class="py-0" style="color:#707070">得票数：<span v-text="vote[0].options.n3.length" v-if="vote[0]"></span>票</v-card-text>
          <v-card-text class="py-0" style="color:#707070" v-if="vote[0]&&vote[0].isAdmitDele===true">委任得票数：<span v-text="vote[0].optionsDele.n3.length" v-if="vote[0]"></span>票</v-card-text>
          <v-card-text class="text-h6 py-0"><font color="#E64550"><span v-text="sum3num"></span>票</font></v-card-text>
          <v-card-text class="text-h4 py-0"><font color="#E64550">{{this.vote[0].voteOptions[2]}}</font></v-card-text>
        </v-col>
        <v-col cols="6">
          <v-card-text class="py-0" style="color:#707070">得票数：<span v-text="vote[0].options.n2.length" v-if="vote[0]"></span>票</v-card-text>
          <v-card-text class="py-0" style="color:#707070" v-if="vote[0]&&vote[0].isAdmitDele===true">委任得票数：<span v-text="vote[0].optionsDele.n2.length" v-if="vote[0]"></span>票</v-card-text>
          <v-card-text class="text-h6 py-0"><font color="#399942"><span v-text="sum2num"></span>票</font></v-card-text>
          <v-card-text class="text-h4 py-0"><font color="#399942">{{this.vote[0].voteOptions[1]}}</font></v-card-text>
        </v-col>
      </v-row>
    </div>
    <div v-else-if="vote[0]&&vote[0].voteType==='自由選択肢'">
      <chart :chartData="chartData" v-if="vote[0]" :options="options" :height="height" :width="width"></chart>
      <v-row>
        <v-col v-for="(vt, index) in vote[0].voteOptions" :key="index" cols="12">
          <div class="d-flex">
            <p class="py-0 my-auto text-center" style="width:50%; font-size:20px;"><font :color="chartData.datasets[0].backgroundColor[index]">{{vt}}</font></p>
            <div>
              <v-card-text class="text-h6 py-0"><font color="ink">{{vote[0].options[`n${index + 1}`].length + vote[0].optionsDele[`n${index + 1}`].length}}票</font></v-card-text>
              <v-card-text class="py-0" style="color:#707070">得票数：<span v-text="vote[0].options[`n${index + 1}`].length" v-if="vote[0]"></span>票</v-card-text>     
              <v-card-text class="py-0" style="color:#707070" v-if="vote[0]&&vote[0].isAdmitDele===true">委任得票数:<span v-text="vote[0].optionsDele[`n${index + 1}`].length" v-if="vote[0]"></span>票</v-card-text>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <!--賛成・反対-->
    <div class="container" v-else-if="vote[0]&&vote[0].voteType==='賛成・反対'">
      <v-row>
        <v-col cols="6">
          <v-card-text class="text-h4 py-0"><font color="#BA0009">反対</font><font color="#BA0009"><span v-text="sum2num"></span>票</font></v-card-text>
          <v-card-text class="py-0" style="color:#707070" v-if="vote[0]&&vote[0].isAdmitDele===true">委任反対票：<span v-text="vote[0].optionsDele.n2.length" v-if="vote[0]"></span>票</v-card-text>
          <v-card-text class="py-0" style="color:#707070">反対票：<span v-text="vote[0].options.n2.length" v-if="vote[0]"></span>票</v-card-text>
        </v-col>
      </v-row>
      <chart :chartData="chartData" v-if="vote[0]" :options="options" :height="height" :width="width"></chart>
      <v-row>
        <v-col cols="6">
          <v-card-text class="py-0" style="color:#707070">賛成票：<span v-text="vote[0].options.n1.length" v-if="vote[0]"></span>票</v-card-text>
          <v-card-text class="py-0" style="color:#707070" v-if="vote[0]&&vote[0].isAdmitDele===true">委任賛成票：<span v-text="vote[0].optionsDele.n1.length" v-if="vote[0]"></span>票</v-card-text>
          <v-card-text class="text-h4 py-0"><font color="#399942">賛成</font><font color="#399942"><span v-text="sum1num"></span>票</font></v-card-text>
        </v-col>
      </v-row>
    </div>
    <!--クアドラティック投票-->
    <div v-else-if="vote[0]&&vote[0].isAdmitQuad">
      <v-row>
        <v-col cols="6" v-if="this.vote[0].voteOptions[3]">
          <v-card-text class="text-h4 py-0"><font color="#E05922">{{this.vote[0].voteOptions[3]}}</font></v-card-text>
          <v-card-text class="text-h6 py-0"><font color="#E05922"><span v-text="sum4num"></span>票</font></v-card-text>
        </v-col>
        <v-col cols="6">
          <v-card-text class="text-h4 py-0"><font color="#008CFF">{{this.vote[0].voteOptions[0]}}</font></v-card-text>
          <v-card-text class="text-h6 py-0"><font color="#008CFF"><span v-text="sum1num"></span>票</font></v-card-text>
        </v-col>
      </v-row>
      <chart :chartData="chartData" v-if="vote[0]" :options="options" :height="height" :width="width"></chart>
      <v-row>
        <v-col cols="6"  v-if="this.vote[0].voteOptions[2]">
          <v-card-text class="text-h6 py-0"><font color="#E64550"><span v-text="sum3num"></span>票</font></v-card-text>
          <v-card-text class="text-h4 py-0"><font color="#E64550">{{this.vote[0].voteOptions[2]}}</font></v-card-text>
        </v-col>
        <v-col cols="6">
          <v-card-text class="text-h6 py-0"><font color="#399942"><span v-text="sum2num"></span>票</font></v-card-text>
          <v-card-text class="text-h4 py-0"><font color="#399942">{{this.vote[0].voteOptions[1]}}</font></v-card-text>
        </v-col>
      </v-row>
    </div>
  </v-card>
          
<!--結果出力画面-->
<v-dialog v-model="result_print" width="40%" class="pa-8 z1000">
  <v-container class="modeResult-print" style="background-color: white">
    <p class="mt-6 mb-0" style="font-size: 25px;">結果の出力形式の選択</p>
    <v-row class="mx-auto my-auto mt-4">
      <v-col align="center" cols="3" class="mx-auto my-auto test_print" style="background-color: #DCDCDC">
        <p class="ma-auto">PDF</p>
      </v-col>
      <v-col align="center" cols="3" class="mx-auto my-auto test_print" style="background-color: #DCDCDC">
        <p class="ma-auto">CSVファイル</p>
      </v-col>
      <v-col align="center" cols="3" class="mx-auto my-auto  test_print" style="background-color: #54E363">
        <p class="white--text ma-auto">LINE</p>
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col align="center" cols="3" class="mx-auto my-auto test_print" style="background-color: #294A66">
        <p class="white--text mb-0">Facebook</p>
      </v-col>
      <v-col align="center" cols="3" class="mx-auto my-auto test_print" style="background-color: #008CFF">
        <p class="white--text mb-0">Messenger</p>
      </v-col>
      <v-col align="center" cols="3" class="mx-auto my-auto test_print" style="background-color: #66BAFF">
        <p class="white--text mb-0">Twitter</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col align="center" cols="11" class="mx-auto mt-4 my-3 test_print" style="background-color: #DCDCDC">
        <p class="mb-0">メール送付</p>
      </v-col>
    </v-row>
    <v-col align="center">
      <v-btn small text @click="result_print=false" class="text-h5 mt-6">
        <span style="color:#008CFF">＜</span>閉じる<span style="color:#008CFF">＞</span>
      </v-btn>
    </v-col>
  </v-container>
</v-dialog>

</div>
</template>

<script>
import Vue from 'vue'
import firebase from "firebase/app"
import "firebase/firestore"
import VueDOMPurifyHTML from 'vue-dompurify-html'
import chart from '../../components/chart.vue'
Vue.use(VueDOMPurifyHTML)
import VueMq from 'vue-mq'
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})
export default{
  mounted(){
    this.db = firebase.firestore() // dbインスタンスを初期化
  },
  components:{
    chart,
  },
  props:{
    aboutpj: Object,
    pjuid: String,
    pjadmins: Array,
    chartData: Object,
    vote: Array,
    sum1num: Number,
    sum2num: Number,
    sum3num: Number,
    sum4num: Number,
    sum5num: Number,
    sum6num: Number,
    sum7num: Number,
    sum8num: Number,
    sum9num: Number,
    sum10num: Number,
    sumnum: Number
  },
  data: (vm) => ({
    db: null,

    //dialog
    result_print:false,

    height: window.innerHeight / 2,
    width: window.innerWidth / 2,
    options: {
      responsive: false,
    },
  }),
  methods: {
  },
  computed: {
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
  }
}
</script>

<style scoped>
.heightSp{
  overflow:hidden scroll;
}
.heightPc{
  max-height:78vh;
  overflow:hidden scroll;
}
.test_print{
  background-color: #DCDCDC;
}
::-webkit-scrollbar {
  display: none;
}
/*
::-webkit-scrollbar-track {
background-color: rgba(120, 170, 210,0.3);
border-radius: 100px;
}
::-webkit-scrollbar-thumb {
background: #78aad2;
border-radius: 100px;
width: 130px;
}
*/
</style>